module.exports = __webpack_public_path__ + "static/media/fcpsr.fa483971.svg";